import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { readableNumber } from '@occc-app/lib/format';

type Props = {
  label: string;
  value: number;
};

export const StatisticsItem: React.FC<Props> = ({ label, value }) => {
  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Typography variant='h4' component='strong'>
        {readableNumber(value)}
      </Typography>
      <Typography color='textSecondary'>{label}</Typography>
    </Box>
  );
};
